module.exports = __webpack_public_path__ + "img/lens-160-plus-03.e6842529.png";